import styled from 'styled-components';

export const ContainerClients = styled.div`
  margin: 50px 0px 50px 10px;

  table {
    margin-top: 20px;
  }

  td {
    height: 30px;
  }

  .filter {
    display: flex;
  }

  h2 {
    margin-bottom: 40px;
  }

  table {
    font-size: 13px !important;
  }

  th:nth-of-type(2) {
    width: 20vw;
  }
  th:nth-of-type(3) {
    width: 10vw;
  }
  th:nth-of-type(4) {
    width: 10vw;
  }
  @media (max-width: 1180px) {
    width: 100%;
    float: none !important;
    margin-left: 0px !important;
  }
`;

export const ContainerAddress = styled.div`
  background-position: top center;
  background-repeat: repeat;
  padding-bottom: 60px;

  .container {
    background-color: #fff;
    padding: 15px;
  }

  input {
    margin: 10px 0px 10px 0px !important;
  }

  .loginDiv {
    padding: 20px;
  }

  .forgottenPass {
  }

  .menuUser p {
    transition: 0.5s;
    margin-top: 10px;
    padding: 10px;
    background: #ededed;
    border-radius: 10px;
  }

  .menuUser {
    transition: 0.5s;
    cursor: pointer;
  }

  .menuUser :hover {
    transition: 0.5s;
    margin-left: 10px;

    a {
      margin: 0px !important;
    }
  }

  .checkTerms {
    display: flex;
    align-items: center;

    label {
      margin-left: 10px;
      margin-bottom: -2px;
    }
  }

  input,
  select {
    margin-bottom: 20px !important;
  }

  .addressCard {
    box-shadow: 0px 0px 10px 3px #ccc;
    padding: 10px;
    border-radius: 7px;
    margin-top: 20px;
  }

  .actionBtn {
    cursor: pointer;
    margin: 10px;
    font-size: 20px;
  }
`;

export const Title = styled.h2`
  padding-top: 25px;
  font-weight: 600;
  font-size: 20px;

  svg {
    margin-right: 10px;
    font-size: 1.2rem;
    margin-bottom: 5px;
  }
`;

export const ContainerLoading = styled.div`
  height: calc(100vh - 7.5rem);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #2c3e50;
    text-align: center;
  }
`;
